import React from "react";
import { makeStyles } from "@material-ui/core";
import MuiPickersUtilsProvider from "@material-ui/pickers/MuiPickersUtilsProvider";
import { KeyboardDatePicker, KeyboardDatePickerProps } from "@material-ui/pickers/DatePicker";
import DateFnsUtils from "@date-io/date-fns";

const useStyles = makeStyles({
  root: {
    minWidth: "100%",
    "& > label": {
      zIndex: 10,
    },
  },
  input: {
    padding: "26px 32px 8px 13px",
  },
});

interface CustomDatePickerProps extends KeyboardDatePickerProps {}

const CustomDatePicker = (props: CustomDatePickerProps) => {
  const classes = useStyles(props);
  const { id, label, disabled, disablePast, helperText, minDate, onChange, value, ...rest } = props;

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <KeyboardDatePicker
        className={classes.root}
        disabled={disabled}
        disablePast={disablePast}
        minDate={minDate}
        margin="normal"
        helperText={helperText}
        id={id}
        inputProps={{
          className: classes.input,
        }}
        label={label}
        format="yyyy/MM/dd"
        value={value}
        onChange={onChange}
        KeyboardButtonProps={{
          "aria-label": "change date",
        }}
        {...rest}
      />
    </MuiPickersUtilsProvider>
  );
};

export default CustomDatePicker;
